export const show = (el) => {
  el.dataset.is_show = 'true';
};

export const hide = (el) => {
  el.dataset.is_show = 'false';
};
